import PowerDate from '#metatypes/power_date.js'
import PowerBool from '#metatypes/power_bool.js'
import { define, type, auto, Record, Collection } from 'type-r'
import ConsentForm from './consent'
import LowerLidEnum from '#metatypes/lower_lid_enum.js'

@define
export default class EntropionForm extends ConsentForm {
    @(type(PowerBool).as) offeredCopy: boolean
    @(type(LowerLidEnum).required.as) lowerLidSide: string    
    @(type(String).as) other: string
}
